import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import ContrattoForm from "./ContrattoForm";
import Actions from "../ContrattiActions";
import Store from "../ContrattiStore";
import { Contratto } from "../../generated";
import { Loading } from "../../common/components/loading";


interface Props extends RouteComponentProps<{ idImpianto: string, idContratto?: string }> {
    contratto?: Contratto;
}
const ContrattoEdit = (props: Props) => {

    const { contratto, history, match: { params: { idImpianto, idContratto } } } = props;
    const idImpiantoNumber = parseInt(idImpianto);
    useEffect(() => {
        if (Store.get(idImpianto) == null)
            Actions.getByImpianto(idImpiantoNumber);
    }, [idImpianto, idContratto])

    const save = (contratto: Contratto) => {

        if (idContratto)
            Actions.update(contratto);
        else
            Actions.add(contratto);
        history.goBack();
    }
    if (idContratto && !contratto)
        return <Loading />
    return (
        <ContrattoForm
            contratto={contratto ?? { idImpianto: idImpiantoNumber }}
            onSubmit={save}
            onCancel={() => history.goBack()}
        />

    );
}


export default withRouter(attach(ContrattoEdit, Store, (store, props) => ({
    contratto: (store.get(props.match.params.idImpianto) || []).find(x => x.id.toString() == props.match.params.idContratto)
})));